import viewport from './viewport'
import StickySidebar from 'sticky-sidebar/dist/sticky-sidebar';
import pageChange from './page-change'
import SimpleBar from 'simplebar';

export default function () {
    if (viewport().width < 360) {
        let mvp = document.getElementById('vp');
        mvp.setAttribute('content','user-scalable=no,width=360');
    }


    pageChange();
    window.onpageshow = function(event) {
        if (event.persisted) {
            window.location.reload()
        }
    };

    setTimeout(function () {
        document.body.classList.add('doc-ready');
    }, 200);

    window.addEventListener('load', function (ev) {
        document.body.classList.add('doc-ready', 'wind-loaded');
    });


    let catalogTextBtn = document.getElementsByClassName('catalog-header__overflow-btn');

    Array.from(catalogTextBtn).forEach(button => button.addEventListener('click', function(e){

        let currentText = this.previousElementSibling;

        if(currentText.classList.contains('is-opened')){

            currentText.style.maxHeight = '';

            currentText.classList.remove('is-opened');
        }
        else{
            let fullHeight = currentText.querySelector('.catalog-header__overflow-cont').clientHeight;

            currentText.style.maxHeight = fullHeight+'px';

            currentText.classList.add('is-opened');
        }

        e.preventDefault();
    }));



    if(viewport().width > 980 && document.getElementsByClassName('js-sticky-col')[0]) {
        window.stickySidebar = new StickySidebar('.js-sticky-col', {topSpacing: 100, resizeSensor: true});
    }

    let anchorLink = document.getElementsByClassName('js-scroll-anchor');

    Array.from(anchorLink).forEach(button => button.addEventListener('click', function(e){
        let currentUrl = this.getAttribute('href');
        currentUrl = currentUrl.replace('#', '');
        let targetElem = document.getElementById(currentUrl);

        if(targetElem){
            let topPos = targetElem.offsetTop;

            window.scroll({
                top: topPos - 100,
                left: 0,
                behavior: 'smooth'
            });
        }

        e.preventDefault();
    }));

    function fallbackCopyTextToClipboard(text) {
        let textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position="fixed";  //avoid scrolling to bottom
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            let successful = document.execCommand('copy');
            let msg = successful ? 'successful' : 'unsuccessful';
            console.log('Fallback: Copying text command was ' + msg);
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
    }

    function copyTextToClipboard(text) {
        if (!navigator.clipboard) {
            fallbackCopyTextToClipboard(text);
            return;
        }
        navigator.clipboard.writeText(text);
    }

    let clipboardBtn = document.getElementsByClassName('js-copy-clipboard');

    Array.from(clipboardBtn).forEach(button => button.addEventListener('click', function(e){
        let currentVal = this.getAttribute('data-val');
        copyTextToClipboard(currentVal);
    }));


    let subscribeFormBtn = document.getElementsByClassName('js-toggle-subscribe');

    Array.from(subscribeFormBtn).forEach(button => button.addEventListener('click', function(e){

        let subscribeForm = document.getElementsByClassName('subscribe-promo__form')[0];
        let subscribeFormSuccess = document.getElementsByClassName('subscribe-promo__success')[0];
        subscribeForm.classList.toggle('is-opened');
        subscribeFormSuccess.classList.remove('is-opened');
        e.preventDefault();
    }));



    let topLink = document.getElementsByClassName('js-scroll-top');

    Array.from(topLink).forEach(button => button.addEventListener('click', function(e){
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        e.preventDefault();
    }));



    if(viewport().width >765 && $('.header-cart-drop__scroll').length > 0) {
        new SimpleBar($('.header-cart-drop__scroll')[0]);
    }
}
